import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto';
import "./styles/globals.css";
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./app/store";
import { createAppRouter, shouldUseHostedVuplexEmbeddedRouter } from "./routes/Routes";

if (process.env.NODE_ENV === "development") {
    window.addEventListener("error", (event) => {
        const message = event?.message || "";
        if (message === "Script error." || message === "Script error") {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);
}

function resolveHostedVuplexRouterDecision() {
    return new Promise((resolve) => {
        if (shouldUseHostedVuplexEmbeddedRouter()) {
            resolve(true);
            return;
        }

        if (window.__ANIMOTIVE_IS_LOCALHOST__) {
            resolve(false);
            return;
        }

        let settled = false;
        const handleVuplexReady = () => {
            if (settled) {
                return;
            }
            settled = true;
            resolve(true);
        };

        window.addEventListener("vuplexready", handleVuplexReady, { once: true });

        window.setTimeout(() => {
            if (settled) {
                return;
            }
            settled = true;
            window.removeEventListener("vuplexready", handleVuplexReady);
            resolve(shouldUseHostedVuplexEmbeddedRouter());
        }, 350);
    });
}

function RouterBootstrap() {
    const [routerState, setRouterState] = React.useState({
        useEmbeddedRouter: null,
        router: null,
    });

    const applyRouterMode = React.useCallback((useEmbeddedRouter) => {
        setRouterState((currentState) => {
            if (currentState.router && currentState.useEmbeddedRouter === useEmbeddedRouter) {
                return currentState;
            }

            return {
                useEmbeddedRouter,
                router: createAppRouter({ useEmbeddedRouter }),
            };
        });
    }, []);

    React.useEffect(() => {
        let isMounted = true;

        resolveHostedVuplexRouterDecision().then((useEmbeddedRouter) => {
            if (!isMounted) {
                return;
            }
            applyRouterMode(useEmbeddedRouter);
        });

        const handleVuplexReady = () => {
            if (!isMounted || window.__ANIMOTIVE_IS_LOCALHOST__) {
                return;
            }

            applyRouterMode(true);
        };

        window.addEventListener("vuplexready", handleVuplexReady);

        return () => {
            isMounted = false;
            window.removeEventListener("vuplexready", handleVuplexReady);
        };
    }, [applyRouterMode]);

    if (!routerState.router) {
        return null;
    }

    return <RouterProvider router={routerState.router}/>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <RouterBootstrap />
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
